import { icons } from "assets";
import Text from "Components/shared/text";
import { useBalanceStore } from "providers/balance";
import React from "react";
import styles from "./cards.module.css";

/**
 * 
 * @param {sm | lg} variant This is the type of variant you want
 * @param {row | col} variant This  specify the position of refresh
 * @returns 
 */
export const MoneyCard = ({ background, symbol, currency, amount, variant="sm", refresh="row", onRefresh=() => {} }) => {
  const {showBalance} = useBalanceStore();
  const [isRefreshing, setIsRefreshing] = React.useState(false);
  const clickHandler = () =>{
    setIsRefreshing(true);
    onRefresh(()=>{
        setIsRefreshing(false);
    })
}
  return (
    <div className={`${styles.background} ${styles[variant]}`} style={{ background: background }}>
      <div className={styles.symbol}>{symbol}</div>
      <Text tag="div">
        <Text tag="div" className={styles.cowrie}>
         {currency}
        </Text>
        <Text tag="div" className={`${styles.innerContainer} ${styles[refresh]}`}>
          <Text tag="div" style={{ fontWeight: "600", marginRight: "1rem" }}>
            {symbol}
            {showBalance ? amount: "***"}
          </Text>
          <img src={icons.refresh} alt="refresh" onClick={clickHandler}
          className={`${isRefreshing ? styles.refresh : ""}`} style={{cursor:"pointer" }} />
        </Text>
      </Text>
    </div>
  );
};
